import { environment } from 'src/environments/environment';

/**
 * True when a request is bound for our own API, and false for anything else the app
 * fetches directly - above all the GCS signed URLs the file browser downloads from.
 *
 * Interceptors use this to keep our headers off third-party hosts. Beyond not handing
 * an unrelated service our tenant id or token, a custom header makes a cross-origin GET
 * non-simple, and the browser then preflights it; GCS answers that preflight without
 * Access-Control-Allow-Origin unless the header is in the bucket's CORS configuration,
 * so the download fails before it starts.
 *
 * Relative URLs (assets and same-origin calls) count as ours.
 */
export function isAppApiRequest(url: string): boolean {
  if (!/^[a-z][a-z0-9+.-]*:\/\//i.test(url)) {
    return true;
  }

  return url.startsWith(environment.apiConfig.baseUri);
}
